import Element from "./_element";
import Component from "./_component";

// Registers the two custom elements. Called from js/elements.js (head, non-deferred, so the
// elements upgrade during HTML parsing) and again from setup() in the deferred index.js
// bundle, which is what still registers them on pages that do not load elements.js.
//
// Each name is guarded separately: define() throws NotSupportedError on a re-registration,
// which would abort the whole bundle, and a single combined guard would skip blue-component
// whenever blue-composition happened to be defined first.
export default function defineElements() {
  const registry = self.customElements;
  if (!registry) return;

  if (!registry.get("blue-composition")) {
    registry.define("blue-composition", Element);
  }
  if (!registry.get("blue-component")) {
    registry.define("blue-component", Component);
  }
}
